import React from 'react';
import { Chatbot } from '@/components/chatbot/chatbot';

const ChatbotPage: React.FC = () => {
  return (
    <div className="container mx-auto p-6 h-full">
      <div className="h-full max-w-4xl mx-auto">
        <Chatbot />
      </div>
    </div>
  );
};

export default ChatbotPage;